import {
  bulkUploadHospitalTranslations,
  bulkUploadHospitals,
  downloadHospitalTranslationsBulkUploadTemplate,
  downloadHospitalsBulkUploadTemplate,
} from "../../../../services/hospitals/hospitals";
import BulkUploadSection from "../../../../components/bulk_upload/bulk_upload_section";
import BulkUploadDialogShell from "../../../../components/bulk_upload/bulk_upload_dialog_shell";

interface BulkUploadHospitalsDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function BulkUploadHospitalsDialog({ open, onClose }: BulkUploadHospitalsDialogProps) {
  return (
    <BulkUploadDialogShell
      open={open}
      onClose={onClose}
      title="Bulk Upload Hospitals"
      createTabLabel="Create Hospitals"
      translationsTabLabel="Add Translations"
      createTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to create many hospitals at once, in English. Download the template first for the exact column format and the valid names for State, Hospital Type, Schemes, Specialities, and Facilities."
          templateFileName="hospitals_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadHospitalsBulkUploadTemplate}
          onUpload={bulkUploadHospitals}
          savedLabel="created"
          listQueryKey="hospitals"
        />
      }
      translationsTabContent={
        <BulkUploadSection
          description="Upload an .xlsx file to add translations to existing hospitals - one row per Hospital ID + language. Find a hospital's ID on the Hospitals list or its details page."
          templateFileName="hospital_translations_bulk_upload_template.xlsx"
          onDownloadTemplate={downloadHospitalTranslationsBulkUploadTemplate}
          onUpload={bulkUploadHospitalTranslations}
          savedLabel="saved"
          listQueryKey="hospitals"
        />
      }
    />
  );
}
